module.exports = __webpack_public_path__ + "img/user.94d02f96.svg";